import coreToggle from '@nrk/core-toggle'
import {
  nrkUserLoggedin,
  nrkClose
} from '@nrk/core-icons'
import { connect } from '@nrk/nrkno-login-connector'

export function initialize () {
  if (typeof document === 'undefined') return
  coreToggle('.nrk-masthead__bars, .nrk-masthead__more', { popup: true })

  const loginLink = document.querySelector('.nrk-masthead__user a')
  if (loginLink) {
    connect((user) => {
      if (user) {
        const span = document.createElement('span')
        const canReplaceState = window.history && window.history.replaceState
        const isAutoLogin = window.location.search.indexOf('autoLogin=true') >= 0

        span.textContent = user.name
        loginLink.innerHTML = nrkUserLoggedin
        loginLink.appendChild(span)

        if (isAutoLogin) {
          const banner = document.body.insertAdjacentElement('afterbegin', document.createElement('div'))

          banner.className = 'nrk-masthead__auto-login-banner'
          banner.innerHTML = `<button>${nrkClose}</button><strong>Hei</strong>, du er nå logget inn på nrk.no, fordi du allerede er innlogget et annet sted hos NRK`
          banner.querySelector('button').addEventListener('click', () => banner.parentElement.removeChild(banner))
          banner.querySelector('strong').textContent = `Hei ${user.name}` // Use textContent for security

          if (canReplaceState) {
            const href = window.location.href.replace(/autoLogin=true&?/, '').replace(/[?|&]$/, '')
            window.history.replaceState(window.history.state, document.title, href)
          }
        }
      }
      loginLink.removeAttribute('hidden')
    })
  }
}
